import * as React from 'react';
import { Popover as AntdPopover } from 'antd';

import { StringMode } from '@comall-backend-builder/types';

export class StringReportsReasonMode extends StringMode {
    /**
     * 失败原因，以气泡形式展示
     */
    public getAvailableDisplayComponent(value: any, displayInfo: any) {
        const { row, conditionProperty } = displayInfo;
        const content = (
            <div style={{maxWidth: 500}}>{value}</div>
        );
        return (
            <div>
                {row[conditionProperty] === 'ERROR' || row[conditionProperty] === 'PART_SUCCESS' ? (
                    <AntdPopover content={content}>
                        <span>{value.slice(0, 5)}...</span>
                    </AntdPopover>
                ) : (
                    <span>-</span>
                )}
            </div>
        );
    }
}
